import React from 'react';
import Slider from 'react-slick';
import { Link } from 'react-router-dom';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import '../styles/ReactSlickHero.css';

const ReactSlickHero = () => {
  // Slider ayarları
  const settings = {
    dots: true,
    infinite: true,
    speed: 700,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    pauseOnHover: true,
    adaptiveHeight: true,
    cssEase: 'ease-in-out',
  };

  // Slider içeriği
  const slides = [
    {
      id: 1,
      // process.env.PUBLIC_URL kullanımını kaldırıp doğrudan path kullanın
      bgImage: "/images/services/Slide1.png",
      title: "GELECEĞİNİZ İLE DÜNYA ARASINDAKİ KÖPRÜ",
      subtitle: "Almanya başta olmak üzere Dünya'nın önde gelen bütün ülkelerinde yeni bir gelecek inşa etmenize destek oluyoruz.",
      cta: "Hizmetlerimizi Keşfedin",
      link: "/hizmetlerimiz"
    },
    {
      id: 2,
      bgImage: "/images/services/Slide2.jpg",
      title: "MAVİ KART İLE AVRUPA'DA ÇALIŞMA İMKANI",
      subtitle: "Nitelikli uzmanlar için Avrupa'da iş ve oturum fırsatları konusunda danışmanlık hizmetleri sunuyoruz.",
      cta: "Detaylı Bilgi Alın",
      link: "/hizmetlerimiz#mavi-kart"
    },
    {
      id: 3,
      bgImage: "/images/services/Slide3.jpg",
      title: "PROFESYONEL DANIŞMANLIK HİZMETLERİ",
      subtitle: "Yurtdışında iş ve yaşam kurma süreçlerinizde uzman kadromuzla yanınızdayız.",
      cta: "Bizimle İletişime Geçin",
      link: "/iletisim"
    },
    {
      id: 4,
      bgImage: "/images/services/Slide4.jpg",
      title: "BİRÇOK ÜLKE İÇİN YANINIZDAYIZ",
      subtitle: "Avrupa'nın önde gelen ülkelerinde çalışma ve oturum imkanları sunuyoruz. ",
      cta: "Ülkeleri Keşfedin",
      link: "/ulkeler"
    }
  ];

  return (
    <section className="hero-slick-slider">
      <Slider {...settings}>
        {slides.map(slide => (
          <div key={slide.id} className="slide-wrapper">
            <div 
              className="slide-inner" 
              style={{ 
                backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(${slide.bgImage})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center'
              }}
            >
              <div className="container">
                <div className="slide-content">
                  <h1>{slide.title}</h1>
                  <p>{slide.subtitle}</p>
                  <Link to={slide.link} className="btn btn-primary">
                    {slide.cta}
                  </Link>
                </div>
              </div>
            </div>
          </div>
        ))}
      </Slider>
    </section>
  );
};

export default ReactSlickHero;